import * as React from "react";
const SvgLockLight = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M11 15.5V11C11 6.02961 15.0289 2 20 2C24.9711 2 29 6.02961 29 11V15.5H30.125C33.2328 15.5 35.75 18.0172 35.75 21.125V32.375C35.75 35.4828 33.2328 38 30.125 38H9.875C6.76859 38 4.25 35.4828 4.25 32.375V21.125C4.25 18.0172 6.76859 15.5 9.875 15.5H11ZM13.25 15.5H26.75V11C26.75 7.27203 23.7266 4.25 20 4.25C16.2102 4.25 13.25 7.27203 13.25 11V15.5ZM6.5 32.375C6.5 34.2383 8.01102 35.75 9.875 35.75H30.125C31.9883 35.75 33.5 34.2383 33.5 32.375V21.125C33.5 19.2617 31.9883 17.75 30.125 17.75H9.875C8.01102 17.75 6.5 19.2617 6.5 21.125V32.375Z" }));
export default SvgLockLight;
